<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  text: string
  position: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left'
}

const props = defineProps<Props>()
const positionClass = computed(() => {
  return `arrow-${props.position}`
})
</script>

<template>
  <div
    :class="`bubble py-2 px-3 rd-2 bg-#fff ${positionClass}`"
  >
    <p class="color-#333 text-3.5 fw-400">
      {{ text }}
    </p>
  </div>
</template>

<style>
.bubble::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border: 10px solid transparent;
  margin-left: -10px;
}

.arrow-top-left::after,
.arrow-bottom-left::after {
  left: 8px; /* Closer to the left edge */
}

.arrow-top-right::after,
.arrow-bottom-right::after {
  right: 8px; /* Closer to the right edge */
  margin-left: 0;
}

.arrow-bottom-left,
.arrow-bottom-right {
  top: 24px;
}

.arrow-bottom-left::after,
.arrow-bottom-right::after {
  bottom: 0;
  border-top-color: #fff;
  border-bottom: 0;
  margin-bottom: -10px;
}

.arrow-top-left,
.arrow-top-right {
  bottom: 24px;
}

.arrow-top-left::after,
.arrow-top-right::after {
  top: 0;
  border-bottom-color: #fff;
  border-top: 0;
  margin-top: -10px;
}
</style>
